module.exports = __webpack_public_path__ + "static/media/1599403601116.35c9fcaf.png";